import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getRubros } from 'api/catalogos';

// eslint-disable-next-line react/prop-types
const Rubros = ({ permission }) => (
  <PlainCRUD
    title="Rubros"
    permission={permission}
    get={getRubros}
    fields={[
      defaultFields.clave,
      {
        name: 'denominacion',
        label: 'Denominacion',
        colWidth: 200,
        required: true,
      },
      {
        name: 'nivel',
        label: 'Nivel',
        colWidth: 200,
        required: true,
      },
    ]}
    readOnly
  />
);

export default Rubros;
